<form>
	<ngx-editor-menu [disabled]="readonly" [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
	<ngx-editor [ariaReadOnly]="readonly" [placeholder]="placeholder ?? ''" [editor]="editor" [formControl]="formControl" outputFormat="html"></ngx-editor>
</form>
